export const createBankAccount = `
    mutation createBankAccount($input: CreateBankAccountInput!) {
        createBankAccount(input:$input) {
          id
          customerId
          country
          currency
          accountHolderName
          accountHolderType
          bankName
          routingNumber
    }
}`;

export const updateBankAccount = `
    mutation updateBankAccount($input: UpdateBankAccountInput!) {
        updateBankAccount(input:$input){
          id
          customerId
          country
          currency
          accountHolderName
          accountHolderType
          bankName
          routingNumber
        }
}`;

export const deleteBankAccount = `
    mutation deleteBankAccount($input: DeleteBankAccountInput!) {
        deleteBankAccount(input:$input) 
}`;
